import { render } from "./Index.vue?vue&type=template&id=3fc98fcd"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Pages/Contact/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fc98fcd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fc98fcd', __exports__)) {
    api.reload('3fc98fcd', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=3fc98fcd", () => {
    api.rerender('3fc98fcd', render)
  })

}


export default __exports__